export default __webpack_public_path__ + "static/Engagement-7470afd8eace0c4232ff808664f749a3.png";